module.exports = __webpack_public_path__ + "static/img/2020-B.b9d3ac7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2020-B.png
// module id = 3Mxi
// module chunks = 1